const COGNITO_CALLBACK_KEYS = new Set(['id_token', 'access_token', 'code', 'error'])

/**
 * True only when the URL has Cognito callback *parameters*, not when those
 * strings appear inside another query value (e.g. Quick Start `action` JSON).
 */
function urlHasCognitoAuthResponse(href) {
  try {
    const url = new URL(href)
    const names = new Set()
    for (const key of new URLSearchParams(url.search).keys()) names.add(key)
    const hash = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash
    if (hash) {
      for (const key of new URLSearchParams(hash).keys()) names.add(key)
    }
    for (const key of names) {
      if (COGNITO_CALLBACK_KEYS.has(key)) return true
    }
    return false
  } catch (e) {
    return false
  }
}

export { urlHasCognitoAuthResponse }
